// app/javascript/controllers/driving_school_payment_method_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "transactionSelect", 
        "regularButton", 
        "paymentButton", 
        "chargeInfo",
        "chargeValidation",
        "notesField",
        "collectTaxGroup",
        "manualSalesTaxGroup"
    ];

    connect() {
        console.log("Payment method controller connected")
        this.handleTransactionTypeChange()
    }

    handleTakePaymentClick(event) {
        let chargeValidation = this.chargeValidationTarget
        chargeValidation.style.display = 'none'
        // if its a charge, we NEED to have a note. So event.preventDefault() and show alert if note is missing.
        if (this.transactionSelectTarget.value === 'charge' && this.notesFieldTarget.value.trim() === '') {
            chargeValidation.style.display = 'block'
            console.log('Charge selected but notes are empty. Preventing submission.')
            event.preventDefault();
            return;
        }
    }

    handleTransactionTypeChange() {
        const selectedValue = this.transactionSelectTarget.value
        const form = this.element
        this.chargeInfoTarget.style.display = 'none'

        if (selectedValue === 'online_payment') {
            // Show payment button, hide regular button
            this.regularButtonTarget.style.display = 'none'
            this.paymentButtonTarget.style.display = 'inline-block'

            if (this.hasCollectTaxGroupTarget) {
                this.collectTaxGroupTarget.style.display = 'block'
            }
            if (this.hasManualSalesTaxGroupTarget) {
                this.manualSalesTaxGroupTarget.style.display = 'none'
            }

            // Ensure form will do a full page submit for Stripe redirect
            form.removeAttribute('data-turbo')
            form.removeAttribute('data-turbo-frame')
            form.setAttribute('data-turbo', 'false')

            console.log('Switched to online payment mode')
        } 
        else if (selectedValue === 'charge') {
            // Show chargeInfo
            this.chargeInfoTarget.style.display = 'block'
            this.regularButtonTarget.style.display = 'inline-block'
            this.paymentButtonTarget.style.display = 'none'
            if (this.hasCollectTaxGroupTarget) {
                this.collectTaxGroupTarget.style.display = 'none'
            }
            if (this.hasManualSalesTaxGroupTarget) {
                this.manualSalesTaxGroupTarget.style.display = 'none'
            }
            form.setAttribute('data-turbo', 'true')
        } 
        else {
            // Show regular button, hide payment button
            this.regularButtonTarget.style.display = 'inline-block'
            this.paymentButtonTarget.style.display = 'none'

            if (this.hasCollectTaxGroupTarget) {
                this.collectTaxGroupTarget.style.display = 'none'
            }
            if (this.hasManualSalesTaxGroupTarget) {
                this.manualSalesTaxGroupTarget.style.display = 'block'
            }

            // Re-enable Turbo for other payment types
            form.setAttribute('data-turbo', 'true')

            console.log('Switched to regular payment mode')
        }
    }
}